import { call, put } from "redux-saga/effects";

import Api from "common/api";
import constants from "./constants";

export default {
  GetContactInfo: function* (data) {
    const __name = constants.GET_CONTACT_INFO;
    try {
      console.log("GetContactInfo", data);
      const res = yield call(Api.GetContactInfo, data.token, data.adAccountId);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
